import { SHIPOUT_TYPES } from '../../constants/custom-store-shipouts.constants';
export const isPFIShipout = type => {
  return type === SHIPOUT_TYPES.PULL_FROM_INVENTORY;
};